import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class DateService {


   constructor(private translateService: TranslateService) {}

   formatDate(date, format = "DD/MM/YYYY", textWithTime = false, nearDates = true) {
      if (date) {
         let oMoment = moment(date, "YYYY-MM-DD");
         if (oMoment.isValid()) {
            if (!nearDates) {
               return oMoment.format(format);
            }
            if (moment().diff(oMoment, "days") === 0) {
               return `${this.translateService.instant("DATE.TODAY")}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
            } else if (moment().diff(oMoment, "days") === -1) {
               return `${this.translateService.instant("DATE.TOMORROW")}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
            } else if (moment().diff(oMoment, "days") === 1) {
               return `${this.translateService.instant("DATE.YESTERDAY")}${textWithTime ? ", " + oMoment.format("HH:mm") : ""}`;
            } else {
               return oMoment.format(format);
            }
         } else {
            return this.translateService.instant("DATE.INVALID");
         }
      } else {
         return null;
      }
   }
}
